import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; 2026 Nevin Ada Çakmak. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
